import { render, staticRenderFns } from "./UpdateBusinessMemberAddress.vue?vue&type=template&id=06d70760&"
import script from "./UpdateBusinessMemberAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessMemberAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports